import React from 'react';
import { Navigate } from 'react-router-dom';
import { Box, CircularProgress, Typography } from '@mui/material';
import { useWebSocket } from './WebSocketContext';

const AuthRoute = ({ children }) => {
  const { isLoginRequired, isUserLoggedIn, isValidatingSession } = useWebSocket();
  
  // If user is not logged in and we're not currently validating, redirect to login
  // This ensures users see the login screen by default
  if (!isUserLoggedIn && !isValidatingSession) {
    // If we know login is required OR we haven't determined yet (null), show login
    if (isLoginRequired === true || isLoginRequired === null) {
      return <Navigate to="/login" replace />;
    }
    // Only allow access without login if explicitly set to false (offline mode)
    if (isLoginRequired === false) {
      return children;
    }
  }
  
  // Show loading while session is being validated
  if (isValidatingSession) {
    return (
      <Box 
        display="flex" 
        flexDirection="column"
        justifyContent="center" 
        alignItems="center" 
        height="100vh"
        sx={{ backgroundColor: '#f5f5f5' }}
      >
        <CircularProgress size={60} />
        <Typography variant="h6" sx={{ mt: 2, color: '#666' }}>
          Authenticating...
        </Typography>
      </Box>
    );
  }

  // If user is logged in, render the protected content
  if (isUserLoggedIn) {
    return children;
  }
  
  // Fallback: redirect to login
  return <Navigate to="/login" replace />;
};

export default AuthRoute;
